// Webpack Imports
//import { createApp, h } from 'vue'

import * as bootstrap from 'bootstrap'
;(function () {
  'use strict'

  // Focus input if Searchform is empty
  ;[].forEach.call(document.querySelectorAll('.search-form'), (el) => {
    el.addEventListener('submit', function (e) {
      var search = el.querySelector('input')
      if (search.value.length < 1) {
        e.preventDefault()
        search.focus()
      }
    })
  })

  // Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
  var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
  var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
    return new bootstrap.Popover(popoverTriggerEl, {
      trigger: 'focus',
    })
  })
})()

var swiper = new Swiper('.proyectosHomeSwiper', {
  slidesPerView: 1,
  spaceBetween: 10,
  freeMode: true,
  loop: true,
  autoplay: {
    delay: 5000,
  },
  navigation: {
    nextEl: '.proyectos-next-btn',
    prevEl: '.proyectos-prev-btn',
  },
  breakpoints: {
    640: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 20,
    },

    1024: {
      slidesPerView: 2,
      spaceBetween: 20,
    },

    // 1440:{
    //   slidesPerView: 5,
    //   spaceBetween: 10,
    // },
  },
})

var swiper = new Swiper('.proyectModalSwiper', {
      pagination: {
        el: ".swiper-pagination",
  },
  autoplay: {
    delay: 3000,
  },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
})

var swiper = new Swiper('.testimoniosHomeSwiper', {
  slidesPerView: 1,
  spaceBetween: 10,
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  speed: 900,
  loop: true,
    autoplay: {
      delay: 7000,
    },
  pagination: {
    el: '.swiper-testimonios-pagination',
    clickable: true,
  },
})

var swiper = new Swiper('.clientesHomeSwiper', {
  slidesPerView: 1,
  spaceBetween: 10,
  speed: 900,
  loop: true,
    autoplay: {
      delay: 3000,
    },
  navigation: {
    nextEl: '.clientes-next-btn',
    prevEl: '.clientes-prev-btn',
  },
  breakpoints: {
    640: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 5,
      spaceBetween: 20,
    },

    1024: {
      slidesPerView: 4,
      spaceBetween: 20,
    },

    // 1440:{
    //   slidesPerView: 5,
    //   spaceBetween: 10,
    // },
  },
})

// START PROYECTOS HOME SLIDER
var swiper = new Swiper('.swiper-container-proyectos', {
  slidesPerView: 1,
  spaceBetween: 30,
  freeMode: true,
  autoplay: {
    delay: 3000,
  },

  pagination: {
    el: '.swiper-pagination-proyectos',
    clickable: true,
  },
  navigation: {
    nextEl: '.next-btn',
    prevEl: '.prev-btn',
  },
  breakpoints: {
    640: {
      slidesPerView: 2,
      spaceBetween: 10,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 10,
    },

    1024: {
      slidesPerView: 2,
      spaceBetween: 10,
    },

    // 1440:{
    //   slidesPerView: 5,
    //   spaceBetween: 10,
    // },
  },
})

// END PROYECTOS HOME SLIDER



// START SERVICIOS SLIDER
var swiper = new Swiper('.serviciosSwiper', {
  slidesPerView: 1,
  spaceBetween: 10,
  freeMode: true,
  autoplay: {
    delay: 3000,
  },
  navigation: {
    nextEl: '.servicios-next-btn',
    prevEl: '.servicios-prev-btn',
  },
  breakpoints: {
    640: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 20,
    },

    1024: {
      slidesPerView: 3,
      spaceBetween: 20,
    },

    // 1440:{
    //   slidesPerView: 5,
    //   spaceBetween: 10,
    // },
  },
})

// END SERVICIOS SLIDER
